import { IUrlData } from './index'

const PARAMS_TO_KEEP = new Set([
  'aivDebug',
  'appDebug',
  'auiDebug',
  'avClientAddress',
  'avCurrentTerritory',
  'avMarketplace',
  'avRecordTerritory',
  'avRegion',
  'avGeoToken',
  'csTools',
  'debug',
  'experiment',
  'forceAV',
  'isDebug',
  'language',
  'pfDisableCache',
  'pfShowFeatures',
  'serviceDebug',
  'inspector',
  'stringDebug'
])

interface IParams {
  [name: string]: string | string[]
}

export interface MakeUrlArgs {
  urlData?: IUrlData
  get?: IParams
  refTag?: string
  isShortUrl?: boolean
}

const filterExistingParams = (params: IParams) =>
  Object.keys(params).reduce(
    (acc, key) =>
      PARAMS_TO_KEEP.has(key) ? { ...acc, [key]: params[key] } : acc,
    {} as IParams
  )

const mergeQueryParams = (existing: IParams, fresh: IParams = {}) => ({
  ...filterExistingParams(existing),
  ...fresh
})

const FOGG_REGION_PREFIX = new RegExp('/region/(na|eu|fe|local)')

const retailPrefix = (isShortUrl: boolean) => isShortUrl ? '' : '/gp/video'

const foggPrefix = ({ originalURI }: IUrlData) => {
  const match = originalURI && originalURI.match(FOGG_REGION_PREFIX)
  return (match && match[0]) || ''
}

export const pathPrefix = (urlData: IUrlData, isShortUrl: boolean) => {
  return urlData.isRetail ? retailPrefix(isShortUrl) : foggPrefix(urlData)
}

const encodedParam = (key: string, value: string) =>
  `${encodeURIComponent(key)}=${encodeURIComponent(value)}`

const avoidDoubleSash = (path: string) => path.replace(/^\//, '')

export const makeUrl = (
  path: string,
  { urlData, get, refTag, isShortUrl = false }: MakeUrlArgs
) => {
  if (!urlData) {
    return ''
  }

  const prefix = pathPrefix(urlData, isShortUrl)
  const contextUrlParams = urlData.parameters || {}

  const mergedParams = mergeQueryParams(contextUrlParams, get)
  const paramsString = Object.keys(mergedParams)
    .reduce((acc: string[], key: string) => {
      const value = mergedParams[key]
      if (Array.isArray(value)) {
        const encodedParams = value.map(v => encodedParam(key, v))
        acc.push(...encodedParams)
      } else {
        acc.push(encodedParam(key, value))
      }
      return acc
    }, [])
    .join('&')
  const actualParams = paramsString ? `?${paramsString}` : ''
  const actualRefTag = refTag ? `/ref=${refTag}` : ''

  return `${prefix}/${avoidDoubleSash(path)}${actualRefTag}${actualParams}`
}
